import type { FinalizePurchasePayload, FinalizePurchaseResponse } from "@api/finalizePurchase";
import { finalizePurchase } from "@api/finalizePurchase";
import { useMutation } from "@tanstack/react-query";

export const useFinalizePurchase = () =>
  useMutation<{ data: FinalizePurchaseResponse; error?: string }, Error, FinalizePurchasePayload>({
    mutationFn: finalizePurchase,
  });
